import { useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { Severity } from "../types";
import { useFetchAdminDetailsQuery, useUpdateAdminMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import AdminForm from "../forms/Admin.form";
import { adminSchema } from "../configs/validations";
import { HIDDEN_PASSWORd } from "../configs";

const EditAdminWrapper = () => {
  const { adminId } = useParams();

  if (!adminId)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Livreur introuvable"
      />
    );

  return <EditAdmin adminId={adminId} />;
};

interface EditAdminProps {
  adminId: string;
}

const EditAdmin: React.FC<EditAdminProps> = ({ adminId }) => {
  const [updateAdmin, { isLoading }] = useUpdateAdminMutation();
  const { data: adminDetails, isFetching } = useFetchAdminDetailsQuery(adminId);

  if (isLoading || isFetching) return <div>Chargement...</div>;

  if (!adminDetails)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Admin introuvable"
      />
    );

  const initialValues = {
    ...adminDetails,
    password: HIDDEN_PASSWORd,
  };

  return (
    <div className="w-full flex flex-col items-center p-4">
      <AdminForm
        initialValues={initialValues}
        validationSchema={adminSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          if (values.password === HIDDEN_PASSWORd) {
            delete values.password;
          }

          const result = await updateAdmin({
            adminId,
            body: values,
          });

          if (!result.error) {
            showToast("Admin mis à jour avec succès", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default EditAdminWrapper;
